<div
    #root
    class="agpr-vi-date-picker"
>
    <button
        #trigger
        type="button"
        class="agpr-vi-date-picker-trigger"
        [class.agpr-vi-date-picker-trigger--open]="isOpen"
        [id]="id"
        [disabled]="disabled"
        aria-haspopup="dialog"
        [attr.aria-expanded]="isOpen"
        [attr.aria-labelledby]="ariaLabelledBy ? ariaLabelledBy + ' ' + id + '_value' : null"
        (click)="togglePanel()"
        (keyup)="$event.stopPropagation()"
        (keydown)="onTriggerKeydown($event)"
    >
        <span class="agpr-vi-date-picker-icon" [ngClass]="icon" aria-hidden="true"></span>

        <span
            [id]="id + '_value'"
            class="agpr-vi-date-picker-value"
        >
            @if (value) {
                {{ displayValue }}
                @if (isMostRecent) {
                    ({{ 'Vi.datePicker.mostRecent' | localize }})
                }
            } @else {
                <span class="agpr-vi-date-picker-placeholder">{{ (placeholder || '') | localize }}</span>
            }
        </span>

        <span class="agpr-vi-date-picker-chevron fa-solid fa-chevron-down" aria-hidden="true"></span>
    </button>

    <agpr-date-picker-overlay
        #overlay
        [anchor]="root"
        [panelStyleClass]="panelStyleClass"
        (opened)="onOverlayOpened($event)"
        (closed)="onOverlayClosed($event)"
        (escape)="closePanel(true)"
    >
        <agpr-date-picker-panel
            #panel
            selectionMode="single"
            [value]="value"
            [defaultDate]="mostRecentDate"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [disabledDates]="disabledDates"
            [disabledDays]="disabledDays"
            [availableDates]="availableDates"
            [disabled]="disabled"
            (valueChange)="onPanelValueChange($event)"
            (dateSelect)="onPanelDateSelect($event)"
            (monthChange)="monthChange.emit($event)"
            (yearChange)="yearChange.emit($event)"
        ></agpr-date-picker-panel>

        @if (mostRecentDate) {
            <div class="agpr-vi-date-picker-footer">
                <button
                    type="button"
                    class="agpr-vi-date-picker-mostRecentButton"
                    (click)="selectMostRecent()"
                >
                    {{ 'Vi.datePicker.mostRecent' | localize }}
                </button>
            </div>
        }
    </agpr-date-picker-overlay>
</div>
